module.exports = __webpack_public_path__ + "static/media/instructor-9.95e12b37.png";